import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { api, useApi } from "../../lib/api";
import { Reveal } from "../Reveal";

const Tags = () => {
  const { data } = useApi("/tags");
  const tags = Array.isArray(data) ? data : [];
  return (
    <div className="flex flex-wrap gap-2.5" data-testid="trending-tags">
      {tags.map((t) => (
        <Link key={t.tag} to={`/search?q=${encodeURIComponent(t.tag)}`} className="kicker border border-ink/30 rounded-full px-4 py-2 hover:bg-ink hover:border-ink hover:text-cream transition-colors" data-testid={`tag-${t.tag.replace(/\s+/g, "-")}`}>
          #{t.tag} <span className="opacity-60">{t.count}</span>
        </Link>
      ))}
    </div>
  );
};

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're on the list. See you Friday.");
      setEmail("");
    } catch {
      toast.error("That email doesn't look right.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="max-w-[1440px] mx-auto px-5 sm:px-10 py-24 grid lg:grid-cols-12 gap-12" data-testid="newsletter-section">
      <Reveal className="lg:col-span-5">
        <p className="kicker text-rose mb-4">Trending tags</p>
        <Tags />
      </Reveal>
      <Reveal className="lg:col-span-7 bg-hot text-ink border-2 border-ink p-8 sm:p-12 relative overflow-hidden" delay={0.1}>
        <span className="absolute -right-6 -top-10 display text-[180px] text-ink/10 select-none" aria-hidden="true">Fri.</span>
        <p className="kicker">The Youth Letter</p>
        <h2 className="display text-5xl sm:text-7xl mt-3 relative">Every Friday,<br />the good stuff.</h2>
        <p className="font-serif italic text-2xl mt-3 max-w-md">Five stories, one playlist and zero spam. Straight to your inbox.</p>
        <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row gap-3 relative">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" className="flex-1 bg-cream text-ink px-5 py-4 rounded-full outline-none focus:ring-2 ring-ink" data-testid="newsletter-email-input" />
          <button disabled={busy} className="group inline-flex justify-center items-center gap-2 bg-ink text-cream rounded-full px-7 py-4 kicker hover:bg-cream hover:text-ink transition-colors disabled:opacity-60" data-testid="newsletter-submit-btn">
            {busy ? "Sending…" : "Subscribe"} <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </button>
        </form>
      </Reveal>
    </section>
  );
};
